import {
    CLEAR_REPORTS,
    GET_DOCUMENT_TRAIL_REPORT,
    GET_DOCUMENT_TRAIL_REPORT_FAILED,
    GET_DOCUMENT_TRAIL_REPORT_SUCCESS,
    GET_INVOICE_REPORT,
    GET_INVOICE_REPORT_FAILED,
    GET_INVOICE_REPORT_SUCCESS,
    GET_MASTER_VIEW_REPORT,
    GET_MASTER_VIEW_REPORT_FAILED,
    GET_MASTER_VIEW_REPORT_SUCCESS,
    GET_STATISTIC_REPORT,
    GET_STATISTIC_REPORT_FAILED,
    GET_STATISTIC_REPORT_SUCCESS,
    GET_USER_AUDIT_TRAIL_REPORT,
    GET_USER_AUDIT_TRAIL_REPORT_FAILED,
    GET_USER_AUDIT_TRAIL_REPORT_SUCCESS,
    GET_USER_MANAGEMENT_REPORT,
    GET_USER_MANAGEMENT_REPORT_FAILED,
    GET_USER_MANAGEMENT_REPORT_SUCCESS,

    GET_MASS_UPDATE_LOG,
    GET_MASS_UPDATE_LOG_FAILED,
    GET_MASS_UPDATE_LOG_SUCCESS,
} from './constants';

const INIT_STATE = {
    page: 1,
    sizePerPage: 10,
    filter: null,
    total: null,
    summary: [],
    detail: [],
    invoiceReports: [],
    userManagementReports: [],
    userAuditTrailsReports: [],
    masterViewReports: [],
    documentTrailsReport: [],
    massUpdateLog: [],
    loading: false,
    error: null
};

const ReportReducers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_REPORTS:
            return {
                ...INIT_STATE
            };
        //////////////// STATISTIC REPORT ////////////////
        case GET_STATISTIC_REPORT:
            return {
                ...state,
                page: action.payload.page,
                summary: [],
                detail: [],
                invoiceReports: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                sizePerPage: action.payload.sizePerPage,
                filter: action.payload.filter,
                loading: true
            };
        case GET_STATISTIC_REPORT_SUCCESS:
            return {
                ...state,
                filter: action.payload.filter,
                total: action.payload.total,
                summary: action.payload.summary,
                detail: action.payload.data,
                loading: false,
                error: null
            };
        case GET_STATISTIC_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_INVOICE_REPORT:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                invoiceReports: [],
                summary: [],
                detail: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                loading: true
            };
        case GET_INVOICE_REPORT_SUCCESS:
            return {
                ...state,
                invoiceReports: action.payload.data,
                total: action.payload.total,
                loading: false,
                error: null
            };
        case GET_INVOICE_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_USER_MANAGEMENT_REPORT:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                invoiceReports: [],
                summary: [],
                detail: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                loading: true
            };
        case GET_USER_MANAGEMENT_REPORT_SUCCESS:
            return {
                ...state,
                userManagementReports: action.payload.data,
                total: action.payload.total,
                loading: false,
                error: null
            };
        case GET_USER_MANAGEMENT_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_USER_AUDIT_TRAIL_REPORT:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                invoiceReports: [],
                summary: [],
                detail: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                loading: true
            };
        case GET_USER_AUDIT_TRAIL_REPORT_SUCCESS:
            return {
                ...state,
                userAuditTrailsReports: action.payload.data,
                total: action.payload.total,
                loading: false,
                error: null
            };
        case GET_USER_AUDIT_TRAIL_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_MASTER_VIEW_REPORT:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                invoiceReports: [],
                summary: [],
                detail: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                loading: true
            };
        case GET_MASTER_VIEW_REPORT_SUCCESS:
            return {
                ...state,
                masterViewReports: action.payload.data,
                total: action.payload.total,
                loading: false,
                error: null
            };
        case GET_MASTER_VIEW_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_DOCUMENT_TRAIL_REPORT:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                invoiceReports: [],
                summary: [],
                detail: [],
                userManagementReports: [],
                userAuditTrailsReports: [],
                masterViewReports: [],
                documentTrailsReport: [],
                loading: true
            };
        case GET_DOCUMENT_TRAIL_REPORT_SUCCESS:
            return {
                ...state,
                documentTrailsReport: action.payload.data,
                total: action.payload.total,
                loading: false,
                error: null
            };
        case GET_DOCUMENT_TRAIL_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        // Mass Update Log
        case GET_MASS_UPDATE_LOG:
            return {
                ...state,
                page: action.payload.page,
                sizePerPage: action.payload.sizePerPage,
                massUpdateLog: [],
                loading: true
            };
        case GET_MASS_UPDATE_LOG_SUCCESS:
            console.log(action.payload);
            
            return {
                ...state,
                massUpdateLog: action.payload,
                loading: false,
                error: null
            };
        case GET_MASS_UPDATE_LOG_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return {...state};
    }
};

export default ReportReducers;
